import { apiFetch } from "./apiClient";

export async function getAllServiceListTypes() {
  const res = await apiFetch(`/api/services/service/service-metadata`);
  if (!res.ok) {
    throw new Error("Failed to fetch service metadata");
  }
  return res.json();
}

export async function getAllTaskMetadata() {
  const res = await apiFetch(`/api/services/task/task-metadata`);
  if (!res.ok) {
    throw new Error("Failed to fetch task metadata");
  }
  return res.json();
}
